export default {
      id: "btn_check_xs-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "sprite.svg#btn_check_xs",
      toString: function () {
        return this.url;
      }
    }